import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { initErrorLogger } from './utils/errorLogger';
import { ThemeProvider } from './utils/ThemeContext';
import { reportWebVitals } from './utils/webVitals';
import { initAnalytics } from './utils/analytics';
import App from './App';
import CookieConsent from './components/CookieConsent';

initErrorLogger();
initAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <App />
        <CookieConsent />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
